import React, { useState } from 'react'

import ShipmentDetails from './ShipmentDetails'
import Dimensions from './Dimensions'
import { Button } from '@material-tailwind/react'
import DeliveryAddress from './DeliveryAddress'
import DilveryModal from './DilveryModal'
import { toast, ToastContainer } from 'react-toastify'
import { supabase } from '../../supabase.config'
import InvoiceDetails from './InvoiceDetails'

const CreateOrderPage = ({ loadingOrder, step, setStep, dimension, setDimension, dimentionData, setDimentionData, subOrders, setSubOrders, dropLocation, setDropLocation, mode, setMode, shippingType, setShippingType, amount, setAmount, weight, setWeight, orderID, setOrderID, lrDetails, setLrDetails, lrNumber, setLrNumber, handleDimensionData, removeDimesion, handleShippingDetails, warehouseList, pickupLocation, setPickupLocation, handleDeliveryInformation, handleBookOrder, userList, user, setUser, orderList, setTotalbox, totalbox, handleConfirmOrder, loading, deliveryAddresses, createdAtInput, setCreatedAtInput, consigneeGST, setConsigneeGST, sellerGST, setSellerGST, invoiceDetail, setInvoiceDetail, invoiceDocument, supportDocument, invoiceList, setInvoiceList, addInvoice, addSupport }) => {
  const steps = [
    {
      id: 'shipment',
      number: '01',
      title: 'Shipment setup',
      description: 'Client, pickup point, LR mode and order metadata.',
      complete: Boolean((user?.name || user?.companyName) && pickupLocation?.pinCode && weight && orderID),
    },
    {
      id: 'dimensions',
      number: '02',
      title: 'Package details',
      description: 'Cartons, dimensions and quantity blocks.',
      complete: dimension.length > 0,
    },
    {
      id: 'delivery',
      number: '03',
      title: 'Delivery destination',
      description: 'Saved address lookup and consignee details.',
      complete: Boolean(dropLocation?.consignee && dropLocation?.address && dropLocation?.zip),
    },
    {
      id: 'invoice',
      number: '04',
      title: 'Invoice details',
      description: 'Invoice entries, GST values and attached documents.',
      complete: invoiceList.length > 0,
    },
  ]

  const [dilveryModal, setDilveryModal] = useState(false)
  const [deliveryAddress, setdeliveryAddress] = useState("")
  const [deliveryName, setdeliveryName] = useState("")
  const [deliveryPhone, setdeliveryPhone] = useState("")
  const [deliveryCompanyName, setdeliveryCompanyName] = useState("")
  const [deliveryPincode, setdeliveryPincode] = useState("")
  const [deliveryCity, setdeliveryCity] = useState("")
  const [deliveryState, setdeliveryState] = useState("")
  const [deliveryClientId, setdeliveryClientId] = useState("")

  const handleDilveryModal = () => {
    setDilveryModal(!dilveryModal)
  }

  const AddDilveryAdress = async () => {
    if (
      !deliveryAddress ||
      !deliveryName ||
      !deliveryPhone ||
      !deliveryCompanyName ||
      !deliveryPincode ||
      !deliveryCity ||
      !deliveryState
    ) {
      toast.error("Please fill all the fields");
      return;
    }

    try {
      const clientId = typeof deliveryClientId === 'object' ? (deliveryClientId?.id || null) : deliveryClientId || null
      const { error } = await supabase.from('delivery_addresses').insert([{
        delivery_address: deliveryAddress,
        delivery_name: deliveryName,
        delivery_phone: deliveryPhone,
        delivery_company_name: deliveryCompanyName,
        delivery_pincode: deliveryPincode,
        delivery_city: deliveryCity,
        delivery_state: deliveryState,
        delivery_client_id: clientId
      }])
      if (error) throw error
      toast.success("Address saved successfully!")
      setDilveryModal(!dilveryModal)
      setdeliveryAddress("")
      setdeliveryName("")
      setdeliveryPhone("")
      setdeliveryPincode("")
      setdeliveryCity("")
      setdeliveryState("")
      setdeliveryCompanyName("")
      setdeliveryClientId("")
    } catch (error) {
      console.error("Supabase error:", error);
      toast.error("Failed to save address.");
    }
  };

  const completedSteps = steps.filter((item) => item.complete).length
  const totalPackages = dimension.reduce((sum, item) => sum + Number(item.count || 0), 0)
  const chargeableWeight = dimension.reduce((sum, item) => (
    sum + ((((Number(item.length) || 0) * (Number(item.width) || 0) * (Number(item.height) || 0)) / 4500) * (Number(item.count) || 0))
  ), 0)

  return (
    <>
      <ToastContainer />
      <DilveryModal setUser={setUser} user={user} userList={userList} AddDilveryAdress={AddDilveryAdress} deliveryAddress={deliveryAddress} setdeliveryAddress={setdeliveryAddress} deliveryName={deliveryName} setdeliveryName={setdeliveryName} deliveryPhone={deliveryPhone} setdeliveryPhone={setdeliveryPhone} deliveryCompanyName={deliveryCompanyName} setdeliveryCompanyName={setdeliveryCompanyName} deliveryPincode={deliveryPincode} setdeliveryPincode={setdeliveryPincode}
        deliveryCity={deliveryCity} setdeliveryCity={setdeliveryCity} deliveryState={deliveryState}
        setdeliveryState={setdeliveryState} deliveryClientId={deliveryClientId} setdeliveryClientId={setdeliveryClientId} handleDilveryModal={handleDilveryModal} setDilveryModal={setDilveryModal} dilveryModal={dilveryModal} deliveryAddresses={deliveryAddresses} />
      <div className='mx-4 md:mx-6 lg:mx-8 py-6'>
        <div className='grid gap-6 xl:grid-cols-[minmax(0,1fr)_340px]'>
          <div className='space-y-5'>
            <ShipmentDetails
              totalbox={totalbox}
              setTotalbox={setTotalbox}
              userList={userList}
              user={user}
              orderList={orderList}
              setUser={setUser}
              warehouseList={warehouseList}
              pickupLocation={pickupLocation}
              setPickupLocation={setPickupLocation}
              dimentionData={dimentionData}
              setDimentionData={setDimentionData}
              setDimension={setDimension}
              dimension={dimension}
              subOrders={subOrders}
              setSubOrders={setSubOrders}
              dropLocation={dropLocation}
              setDropLocation={setDropLocation}
              mode={mode}
              setMode={setMode}
              shippingType={shippingType}
              setShippingType={setShippingType}
              amount={amount}
              setAmount={setAmount}
              weight={weight}
              setWeight={setWeight}
              lrNumber={lrNumber}
              setLrNumber={setLrNumber}
              orderID={orderID}
              setOrderID={setOrderID}
              lrDetails={lrDetails}
              setLrDetails={setLrDetails}
              createdAtInput={createdAtInput}
              setCreatedAtInput={setCreatedAtInput}
              step={step} setStep={setStep} />
            <Dimensions
              handleDimensionData={handleDimensionData}
              removeDimesion={removeDimesion}
              dimentionData={dimentionData}
              setDimentionData={setDimentionData}
              setDimension={setDimension}
              dimension={dimension}
              subOrders={subOrders}
              setSubOrders={setSubOrders}
              dropLocation={dropLocation}
              setDropLocation={setDropLocation}
              mode={mode}
              setMode={setMode}
              amount={amount}
              setAmount={setAmount}
              weight={weight}
              setWeight={setWeight}
              lrNumber={lrNumber}
              setLrNumber={setLrNumber}
              orderID={orderID}
              setOrderID={setOrderID}
              lrDetails={lrDetails}
              setLrDetails={setLrDetails}
              step={step} setStep={setStep} />
            <DeliveryAddress
              deliveryAddresses={deliveryAddresses}
              handleDilveryModal={handleDilveryModal}
              dropLocation={dropLocation}
              setDropLocation={setDropLocation}
            />
            <InvoiceDetails
              consigneeGST={consigneeGST}
              setConsigneeGST={setConsigneeGST}
              sellerGST={sellerGST}
              setSellerGST={setSellerGST}
              invoiceDetail={invoiceDetail}
              setInvoiceDetail={setInvoiceDetail}
              addInvoice={addInvoice}
              invoiceDocument={invoiceDocument}
              addSupport={addSupport}
              supportDocument={supportDocument}
              invoiceList={invoiceList}
              setInvoiceList={setInvoiceList}
            />
          </div>

          <div className='xl:sticky xl:top-[108px] xl:self-start'>
            <div className='rounded-[28px] border border-slate-200 bg-[linear-gradient(180deg,_rgba(255,255,255,0.98),_rgba(248,250,252,0.95))] p-5 shadow-[0_20px_50px_rgba(15,23,42,0.08)]'>
              <div className='grid gap-3 border-b border-slate-100 pb-4 sm:grid-cols-2'>
                <div className='rounded-[22px] border border-slate-200 bg-white px-4 py-3'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Progress</p>
                  <p className='mt-1 text-sm font-[GilroyBold] text-slate-900'>{completedSteps} / {steps.length} steps ready</p>
                </div>
                <div className='rounded-[22px] border border-slate-200 bg-white px-4 py-3'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Pickup</p>
                  <p className='mt-1 truncate text-sm font-[GilroyMedium] text-slate-800'>{pickupLocation?.pickupName?.name || 'Not selected'}</p>
                </div>
                <div className='rounded-[22px] border border-slate-200 bg-white px-4 py-3'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Packages</p>
                  <p className='mt-1 text-sm font-[GilroyMedium] text-slate-800'>{totalPackages || 0} items</p>
                </div>
                <div className='rounded-[22px] border border-slate-200 bg-white px-4 py-3'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Destination</p>
                  <p className='mt-1 truncate text-sm font-[GilroyMedium] text-slate-800'>{dropLocation?.city || 'Not selected'}</p>
                </div>
              </div>

              <div className='mt-5 space-y-3'>
                {steps.map((item) => (
                  <div key={item.id} className={`rounded-[22px] border px-4 py-4 ${
                    item.complete ? 'border-[#fed7aa] bg-[#fffaf6]' : 'border-slate-200 bg-white'
                  }`}>
                    <div className='flex items-start gap-3'>
                      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-sm font-[GilroyBold] ${
                        item.complete ? 'bg-[#f97316] text-white' : 'bg-slate-100 text-slate-500'
                      }`}>
                        {item.number}
                      </div>
                      <div className='min-w-0'>
                        <div className='flex items-center gap-2'>
                          <p className='text-sm font-[GilroyBold] text-slate-900'>{item.title}</p>
                          <span className={`rounded-full px-2 py-0.5 text-[10px] font-[GilroyBold] uppercase tracking-[0.12em] ${
                            item.complete ? 'bg-[#dcfce7] text-[#15803d]' : 'bg-slate-100 text-slate-500'
                          }`}>
                            {item.complete ? 'Ready' : 'Pending'}
                          </span>
                        </div>
                        <p className='mt-1 text-xs leading-5 text-slate-500'>{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className='mt-5 rounded-[24px] border border-slate-200 bg-white px-4 py-4 text-slate-950 shadow-[0_18px_34px_rgba(15,23,42,0.08)]'>
                <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.18em] text-slate-400'>Live summary</p>
                <div className='mt-3 space-y-2 text-sm'>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>Client</span>
                    <span className='truncate text-right font-[GilroyBold] text-slate-950'>{user?.companyName || user?.name || 'Not selected'}</span>
                  </div>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>LR Number</span>
                    <span className='truncate text-right font-[GilroyBold] text-slate-950'>{lrNumber || 'Pending'}</span>
                  </div>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>Weight</span>
                    <span className='font-[GilroyBold] text-slate-950'>{weight || 0} kg</span>
                  </div>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>Package count</span>
                    <span className='font-[GilroyBold] text-slate-950'>{totalPackages || 0}</span>
                  </div>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>Chargeable wt.</span>
                    <span className='font-[GilroyBold] text-slate-950'>{Math.ceil(chargeableWeight || 0)} kg</span>
                  </div>
                  <div className='flex items-center justify-between gap-3'>
                    <span className='text-slate-500'>Invoices</span>
                    <span className='font-[GilroyBold] text-slate-950'>{invoiceList.length || 0}</span>
                  </div>
                </div>
              </div>

              <div className='mt-5 rounded-[24px] border border-slate-200 bg-white p-4'>
                <p className='text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Ready to submit</p>
                <p className='mt-2 text-sm text-slate-500'>Confirm the order once shipment, package and delivery details are complete.</p>
                <Button
                  disabled={loadingOrder}
                  onClick={handleConfirmOrder}
                  className='mt-4 w-full rounded-full bg-[#f97316] px-8 py-3 text-sm font-[GilroyBold] text-white shadow-[0_14px_30px_rgba(249,115,22,0.2)] hover:bg-[#ea580c]'
                >
                  {loadingOrder ? "Placing Order..." : "Confirm Order"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateOrderPage
